import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [{
  path: '/index',
  name: 'index',
  component: () => import('../views/index.vue'),
  meta: {
    requiresAuth: true
  }
},
{
  path: '/',
  name: 'monitor',
  component: () => import('../views/monitor.vue'),
  meta: {
    requiresAuth: true
  }
}
]

const router = new VueRouter({
  routes
})

// 全局路由守衛
router.beforeEach((to, from, next) => {
  // 檢查該路由是否需要登錄
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 檢查用戶是否已登錄
    if (!store.getters.isLoggedIn) {
      // 用戶未登錄，設置需要顯示登錄彈窗的標誌
      store.commit('SET_LOGIN_STATE', false)
      // 仍然允許訪問路由，但會在組件中顯示登錄彈窗
      next()
    } else {
      // 用戶已登錄，正常訪問
      next()
    }
  } else {
    // 不需要登錄的路由，直接訪問
    next()
  }
})

export default router